(function ($) {
    "use strict";

    $(function () {
        $.formatNumber = function formatNumber(num, isFloat) {
            let formattedNumber;
            if (!isFloat) {
                formattedNumber = Math.round(num);
            } else {
                // Removes trailing zeros and a trailing comma if it's a float
                formattedNumber = parseFloat(num.toFixed(2));
            }
            // Format number with space as thousand separator
            return new Intl.NumberFormat('hu-HU').format(formattedNumber);
        }

        $.animateCounter = function animateCounter(counter, targetValue, duration) {
            let startTime = null;
            const isFloat = Math.floor(targetValue) !== targetValue;

            function step(timestamp) {
                if (!startTime) startTime = timestamp;
                const progress = timestamp - startTime;
                const now = Math.min(progress / duration, 1) * targetValue;

                counter.textContent = $.formatNumber(now, isFloat);

                if (progress < duration) {
                    requestAnimationFrame(step);
                }
            }

            requestAnimationFrame(step);
        }

        if ($('.js-template-marina-city').length == 0) {
            const counters = document.querySelectorAll(".js-counters");
            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.intersectionRatio > 0) {
                        entry.target.querySelectorAll(".js-counter").forEach((counter) => {
                            const targetValue = parseFloat(counter.querySelector(".js-counter__number").textContent.replace(/\s/g, '').replace(',', '.'));
                            $.animateCounter(counter.querySelector(".js-counter__number"), targetValue, 5000);
                        });

                        observer.unobserve(entry.target);
                    }
                });
            });

            counters.forEach((counter) => {
                observer.observe(counter);
            });

        }

    });
})(jQuery);




